import { VIEWS } from './constants/views';

export const VIEW_TO_PATH = {
  [VIEWS.TIMELINE]: '/timeline',
  [VIEWS.PROJECTS]: '/projets',
  [VIEWS.TEAM]: '/equipe',
  [VIEWS.TIMESHEETS]: '/feuilles-heures',
  [VIEWS.JIRA]: '/jira',
  [VIEWS.CRM_HOME]: '/crm',
  [VIEWS.CRM_DEALS]: '/crm/affaires',
  [VIEWS.CRM_CONTACTS]: '/crm/contacts',
  [VIEWS.CRM_FINANCE]: '/crm/finance',
  [VIEWS.CRM_TENDERS]: '/crm/appels-offres',
  [VIEWS.LEAVE]: '/conges',
  [VIEWS.PROFILE]: '/profil',
};

export const PATH_TO_VIEW = Object.fromEntries(
  Object.entries(VIEW_TO_PATH).map(([view, path]) => [path, view]),
);

export const VIEW_TITLES = {
  [VIEWS.TIMELINE]: 'Timeline',
  [VIEWS.PROJECTS]: 'Projets',
  [VIEWS.TEAM]: 'Équipe',
  [VIEWS.TIMESHEETS]: 'Feuilles d’heures',
  [VIEWS.JIRA]: 'Jira',
  [VIEWS.CRM_HOME]: 'CRM',
  [VIEWS.CRM_DEALS]: 'Affaires',
  [VIEWS.CRM_CONTACTS]: 'Contacts',
  [VIEWS.CRM_FINANCE]: 'Dashboard financier',
  [VIEWS.CRM_TENDERS]: 'Appels d’offres',
  [VIEWS.LEAVE]: 'Congés et absences',
  [VIEWS.PROFILE]: 'Mon profil',
};

export const MANAGER_ONLY_VIEWS = [
  VIEWS.PROJECTS,
  VIEWS.TEAM,
  VIEWS.JIRA,
  VIEWS.CRM_HOME,
  VIEWS.CRM_DEALS,
  VIEWS.CRM_CONTACTS,
  VIEWS.CRM_FINANCE,
  VIEWS.CRM_TENDERS,
];
